import Label from "lib/Label";
import React from "react";
import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { getAddressList, getWorkflowData} from "api/formDisplay";
import {getAllOptionList,fetchRegionInfoByTerritoryName,fetchDistrictInfo,fetchSubRegisterOfficeInfo} from "api/formDisplay"
import {fetchUsersByCustomFilters,fetchReportingManagerInfo,checkMaxAttempts} from 'api/user'
import { fetchWorkflow } from "api/formDisplay";
import Toast from "components/ToastComponent";
import { assignPoc } from "helper/userHierarchy";

const CustomDropdown = (props) => {
  var {
    options,
    options_type,
    label,
    web_grid_col,
    mobile_grid_col,
    onChange,
    placeholder,
    name,
    value: userValue,
    class_name,
    togglecopy,
    togglesublable,
    error,
    copyToClipboard,
    selectedData,
    setSelectedData,
    size,
    isEditable,
    is_disabled,
    validators,
    events,
    name,
    dependentfield,
    fetch_reporting_manager,
    check_attempts,
    keys_to_consider,
    type_of_list,
    hierarchy_required,
    clearFieldError,
    dashboard_listing_assign
    // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
  } = props;  
  const formData = useSelector((state) => state.formData.selectedData);    
  const dispatch = useDispatch();
  const addressList = useSelector((state) => state.staticData?.addressList);
  const status = useSelector((state) => state.staticData?.status);
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const isToggled = useSelector((state) => state.formData.isToggled);
  const config = useSelector(( state) => state.configurationReducer?.config);
  const TerritoryList = useSelector((state) => state.staticData?.TerritoryList);
  const CompanyList = useSelector((state) => state.staticData?.CompanyList);
  const RegionList = useSelector((state) => state.staticData?.RegionList);
  const UnitList = useSelector((state) => state.staticData?.UnitList);
  const districtList = useSelector((state)=> state?.staticData?.districtList)
  const subregisterofficeList = useSelector((state)=> state?.staticData?.subregisterofficeList)
  const allOptionList = useSelector((state) => state.staticData?.allOptionList);
  const tableListingData = useSelector(state => state.dashboardReducer.tableListingData);
  const subWfId = useSelector((state) => state.urlEncryption?.urlId?.subWfId);
    const { dashboardConfig } = useSelector((state) => state.dashboardReducer);

  const [internalPOCUpdatedSuccessfully, setInternalPOCUpdatedSuccessfully] =useState(false);
  const [dashboardTableListingData, setDashboardTableListingData] = useState(tableListingData);
  const [disableField, setDisableField] = useState(false);
  const [numberofAttempts, setNumberofAttempts] = useState(0);
  const [checkAttempts, setCheckAttempts] = useState(false);
  const [dropdownInteracted, setDropdownInteracted] = useState(false);

  const [toast, setToast] = useState(false); 
  // const step_history = useSelector((state) => state.)
  const recursiveFormData = useSelector(
    (state) => state.recursive.recursiveFormData
  );
  const loggedInUserInfo = useSelector((state) => state.loggedInUserInfo?.userAuthInfo)
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  const fetchRegion = (territory) => {
    if (events && TerritoryList?.length > 1) {
      let payload = {
        organisation_id: config?.organisation_id,
        _id: loggedUserId,
        territory: territory,
        setSelectedData: setSelectedData,
        dependentfield: dependentfield
      }
      // dispatch(clearSpecificFields(dependentfield))
      dispatch(fetchRegionInfoByTerritoryName(payload))
      }
    }
    const getFilteredOptions = (keysToConsider,optionKey) =>{
      let obj = keysToConsider?.reduce((acc, item) => {
        acc[item] = selectedData[item];
        return acc;
      }, {})
      if(obj){
      const filteredData = allOptionList?.filter((item) =>
        Object.entries(obj).every(([key, value]) => value !== undefined && item[key] === value)
    );
    let optionArray = filteredData?.map((item) => item?.[optionKey]).filter((value) => value !== undefined); // Remove undefined values
       optionArray = [...new Set(optionArray)]
       let result = {
        optionKey : optionKey,
        optionArray : optionArray
       }
        return result;
    }
  }

  const handleCustomDropdown = (e) => {
    const { name, value } = e.target;  
    clearFieldError(name);
    dispatch(setSelectedData({ key: name, value }));
    const customObj = e.target.options[e.target.selectedIndex]?.getAttribute("customValue");
    if (customObj) {
      let res = JSON.parse(customObj);
      if (typeof res === "object") {
        for (const [field, data] of Object.entries(res)) {
          dispatch(setSelectedData({ key: `${name}_${field}`, value: data }));
        }
      } else {
        const data = customObj?.replace(/"/g, "");
        dispatch(setSelectedData({ key: `${name}_custom_field`, value: data }));
      }
    }
    setDropdownInteracted(true);
  };
  
  

  useEffect(() => {
    if (dropdownInteracted && selectedData[name]
    ) {
      if(dependentfield?.length){
      dependentfield?.forEach(field => {
        dispatch(setSelectedData({ key: field, value: '' }))
      })
    }
    if (
      events?.onChange
    ) {
      try {
        eval(events?.onChange);
      } catch (error) {
        console.error("Error executing onChange event:", error);
      }
    }
  }
  }, [selectedData[name], events?.onChange, dropdownInteracted]);

    useEffect(() => {
    if(options_type == "getAddressList"){
      let payload = {
        organisation_id : config?.organisation_id,
      }
      dispatch(getAddressList(payload))
    }else  if(options_type?.toLowerCase() === "district" && !districtList?.length ){
      let payload = {
        organisation_id : config?.organisation_id,
      }
      dispatch(fetchDistrictInfo(payload))
    }else  if(options_type?.toLowerCase() === "subregoffice" && selectedData?.sub_register_district){
      let payload = {
        combined_district_name : selectedData?.sub_register_district
      }
      dispatch(fetchSubRegisterOfficeInfo(payload))
    } else if(options_type == "getAllOptionList"){
      let payload = {
        organisation_id: config?.organisation_id || dashboardConfig?.organisation_id,
        type_of_list : type_of_list,
        wf_configuration_id: selectedData?.configuration_id || dashboardConfig?.wf_configuration_id,
      }
      dispatch(getAllOptionList(payload))
    }
  },[])

    if (options_type == "getAddressList") {
      options = [];
      options.push({ label: "Select", value: ""});
      for (let i in addressList) {
        let paramObj = {};
        if ("label" in addressList[i]) {
          paramObj.label = addressList[i]?.label;
          paramObj.value = addressList[i]?.label;
          paramObj.show = addressList[i]?.show;
          paramObj.customValue = JSON.stringify(addressList[i]?.customValue);  

          options.push(paramObj);
        }
      }
    }else if( options_type?.toLowerCase() == "district" && districtList?.length){
      options = [];
      options.push({ label: "Select", value: ""});
      districtList?.forEach(district => {
        options.push({ label: district, value: district });
      });
    }else if(options_type?.toLowerCase() === "subregoffice" && subregisterofficeList?.length){
      options = [];
      options.push({ label: "Select", value: ""});
      subregisterofficeList?.forEach(office => {
        options.push({ label: office?.combined_branch_name, value: office?.combined_branch_name });
      });
    }else if (options_type == "getAllOptionList") {
      options = [];
      options.push({ label: "Select", value: ""});
        let list = allOptionList?.map(item => item?.[name]);
        list = [...new Set(list)];
      for (let i in list) {
        let paramObj = {};
          paramObj.label =list?.[i] ;
          paramObj.value = list?.[i] ;
          options.push(paramObj);
      }
    }else if (options_type == "getFilteredList") {
     let filteredResult =  getFilteredOptions(keys_to_consider,name)
     let filteredData = filteredResult?.optionArray
      options = [];
      options.push({ label: "Select", value: ""});
      for (let i in filteredData) {
        let paramObj = {};
          paramObj.label = filteredData[i];
          paramObj.value = filteredData[i];
          options.push(paramObj);
      }    
  }
  const IndirectEval = (evalString) =>{
    return eval(evalString)
  }
  const onClick=async (item)=>{
    if(events){
     IndirectEval(events?.onClick)
    }
  }
  const [defaultValue, setDefaultValue] = useState();
  useEffect(() => {
    !selectedData[name] && setDefaultValue("Select");
  }, []);
    

  useEffect(() => {
    const fetchData = async() =>{
      if(check_attempts){
        let workflowInfo = await getWorkflowData(subWfId)
        let attempts = workflowInfo?.source_data?.[name + "_attempts"]?.number_of_attempts ? workflowInfo?.source_data?.[name + "_attempts"]?.number_of_attempts : 0
        setNumberofAttempts(attempts)
        let lastUpdatedAt = new Date(workflowInfo?.source_data?.[name + "_attempts"]?.last_updated_at)
        let enableAt = new Date(lastUpdatedAt.setMinutes(lastUpdatedAt.getMinutes() + validators?.max_time_in_min));
        let currentDate = new Date()
        if(numberofAttempts == validators?.max_attempts){
          setDisableField(true)
          if(currentDate > enableAt) {
            let attemptObj = { 
              workflowId : subWfId,
              name : name + "_attempts",       
              reset : true
            }
             await checkMaxAttempts(attemptObj)
            setDisableField(false)
            setCheckAttempts(true)
           }
        }
       
      }
    }
    fetchData()
  }, [numberofAttempts,checkAttempts])

  const fetchUserHierarchy = async (params) => {   
    try {
      let obj = {
        wf_configuration_id: selectedData?.configuration_id || dashboardConfig?.wf_configuration_id,
        custom_filters: params?.reduce((acc, item) => {
          acc[item] = selectedData[item];
          return acc;
        }, {})
      };
      if (check_attempts && numberofAttempts < validators?.max_attempts && !dashboard_listing_assign) {
        setCheckAttempts(false)

        const attemptObj = { 
          workflowId: subWfId,
          name : name + "_attempts",       
          maxAttempts: validators?.max_attempts,
          bufferTime: validators?.max_time_in_min
        };
        let res = await checkMaxAttempts(attemptObj);
        setCheckAttempts(true)
      } 
      let paramObj = {
        customKeys : obj,
        selectedData :selectedData,
        workflowId :subWfId,
        fetchReportingManager : fetch_reporting_manager,
        hierarchy_required : hierarchy_required,
        dashboard_listing_assign: dashboard_listing_assign
      }  
      let result = await assignPoc(paramObj,dispatch,dashboardTableListingData,setDashboardTableListingData,setInternalPOCUpdatedSuccessfully) 
    } catch (error) {
      console.error("Error in fetchUserHierarchy:", error);
    }
  };
  



  
  const handleCloseToast = () => {
    setInternalPOCUpdatedSuccessfully(false);
    setToast(false)
  };

  return (
    <div className={size}>
        {internalPOCUpdatedSuccessfully && (
                      <Toast
                          // onClose setInternalPOCUpdatedSuccessfully to false and show toast for 3 seconds
                          onClose={() => handleCloseToast}
                          message="Internal POC updated successfully!"
                          type="success"
                          autoClose={3000}
                      />
                  )}
      <Label
        label={label}
        togglecopy={togglecopy}
        togglesublabel={togglesublable}
        copyToClipboard={copyToClipboard}
        selectedData={selectedData}
        setSelectedData={setSelectedData}
        validators={validators}
      />

      <select
        className={`dropdown_container mt-0 ${errorClass} ${
          !isEditable && "radioDisabled" 
        } `}
        value={
          selectedData[name]}
        onChange={handleCustomDropdown}
        name={name}
        id={name}
        onClick={onClick}
        placeholder={placeholder}
        disabled={
          (eval(is_disabled)  || disableField)
            ? true
            : !isEditable ||
              (isToggled &&
                ((userValue?.label && userValue?.label?.length) ||
                  selectedData[name]?.length))
        }
        
      >
        {options?.map((option, index) => {
          const { label, value,is_disabled,customValue} = option;
          const show= option.show ? eval(option.show) : true;
          if(!show) return null;
          return (
         
            <option
              key={index}
              value={value}
              customValue={customValue}
              defaultValue={userValue?.label && userValue?.label == value}
              className={`dropdown_list ${eval(is_disabled) ? 'text-muted':'text-dark'}`}
              disabled = {(eval(is_disabled)) ? true :false}
            >
              {label}
            </option>
          );
        })}
        
      </select>
      {error?.length !== 0 && <ErrorMessage error={error} />}
    </div>

  );
};

export default CustomDropdown;
